import { featuresExtentField, SelectionData } from "@arcgis/charts-shared-utils";
import { WebChartDataItem } from "@arcgis/charts-spec";
import { isEqual } from "lodash-es";

/**
 * Default timers for debouncing.
 */
export const DebounceTimers = {
  ModelConfigChange: 5 as const
};

/**
 * Takes a map from event names to handler functions, then adds listeners for each event
 * @param listeningTarget Target on which the event listeners will be added
 * @param events Map of events
 */
export function addEventListenersFromMap(
  listeningTarget: EventTarget,
  events: Map<string, (e: CustomEvent) => void>
): void {
  events.forEach((handler, eventName) => {
    listeningTarget.removeEventListener(eventName, handler);
    listeningTarget.addEventListener(eventName, handler);
  });
}

/**
 * Util function to know if the selection data changed.
 * The selection items and selection OIDs are compared, not the selection source nor the selection indexes.
 */

/**
 * Util function to know if the selection data changed.
 * The selection items and selection OIDs are compared, not the selection source nor the selection indexes.
 * @param selectionA The first selection data
 * @param selectionB The second selection data
 * @returns a boolean indicating whether the two selections are equal
 */
export function hasSelectionChanged(selectionA?: SelectionData, selectionB?: SelectionData): boolean {
  let { selectionItems: selectionItemsA } = selectionA ?? {};
  const { selectionOIDs: selectionOIDsA } = selectionA ?? {};
  let { selectionItems: selectionItemsB } = selectionB ?? {};
  const { selectionOIDs: selectionOIDsB } = selectionB ?? {};

  // removing extra fields to avoid false positives
  const removeExtraFields = (item: WebChartDataItem) => ({ ...item, [featuresExtentField]: undefined });
  if (selectionItemsA !== undefined) {
    selectionItemsA = selectionItemsA.map(removeExtraFields);
  }
  if (selectionItemsB !== undefined) {
    selectionItemsB = selectionItemsB.map(removeExtraFields);
  }

  const selectionItemsChanged = !isEqual(selectionItemsA, selectionItemsB);
  const selectionOIDsChanged = !isEqual(selectionOIDsA, selectionOIDsB);

  return selectionItemsChanged || selectionOIDsChanged;
}
